<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  mounted() {
    window.receiveDataFromUnity = (data) => {
      if (
        window.__vueUnityHandler &&
        typeof window.__vueUnityHandler === "function"
      ) {
        window.__vueUnityHandler(data);
      } else {
        // console.warn("⚠️ 未设置接收处理函数，数据被忽略:", data);
      }
    };
  },
};
</script>
<style lang="scss">
#app {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
